export { default as withTokenVerified } from 'secured/hocs/withTokenVerified';
export { default as withCompanySelected } from 'secured/hocs/withCompanySelected';
export { default as withSubcompanySelected } from 'secured/hocs/withSubcompanySelected';



// WEBPACK FOOTER //
// src/modules/secured/hocs/index.js